module.exports = __webpack_public_path__ + "img/08-MobileGames-02.72287217.png";